import { Component, OnDestroy, OnInit } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModel } from '../../model/menu.model';
import { AppService } from '../../core/service/app.service';
import { CoreApiService } from '../../core/service/core-api-service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    SidebarModule,
    ButtonModule,
    AvatarModule,
    MenubarModule,
    BadgeModule,
    MenuModule,
    TooltipModule,
    CommonModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnInit, OnDestroy {
  menus: MenuModel[] = [];
  userName: string = '';
  storeLogo: string | null = null;
  hasRetriedLogo: boolean = false;
  private logoSub?: Subscription;

  constructor(
    private readonly util: AppService,
    private readonly apiService: CoreApiService,
  ) {}

  ngOnInit() {
    const data = this.util.returnMenu();
    this.userName = this.util.returnUser();
    if (data) {
      this.menus = JSON.parse(data) as MenuModel[];
    }

    this.storeLogo = this.util.returnStoreLogo();
    this.logoSub = this.util.storeLogo$.subscribe((url) => {
      this.storeLogo = url;
    });

    const storeId = this.util.returnStoreId();
    if (storeId) {
      const ts = this.util.returnStoreLogoTimestamp();
      const elevenHoursMs = 11 * 60 * 60 * 1000;
      if (!ts || Date.now() - ts > elevenHoursMs) {
        this.util.fetchMyLogo(this.apiService);
      }
    }
  }

  // La clase `pinned-sidebar` (solo íconos) aplica únicamente desde 768px; por debajo el texto siempre se ve.
  get isCollapsed(): boolean {
    return this.util.isSidebarPinned && window.matchMedia('(min-width: 768px)').matches;
  }

  onLogoError(): void {
    if (!this.storeLogo) {
      return;
    }
    const storeId = this.util.returnStoreId();
    if (!storeId || this.hasRetriedLogo) {
      this.storeLogo = null;
      return;
    }
    this.hasRetriedLogo = true;
    this.util.fetchMyLogo(this.apiService, (newUrl) => {
      if (!newUrl) {
        this.storeLogo = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.logoSub?.unsubscribe();
  }
}
